import { Autocomplete, Button, FormControlLabel, Grid, IconButton, Paper, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import Container from 'src/components/container/Container'
import CustomInput from 'src/components/customerinput/CustomerInput';
import { VendorContext } from 'src/contexts/VendorContext';
import PercentIcon from '@mui/icons-material/Percent';
import { handleKeyPress } from 'src/functions';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { notify } from 'src/components/notify';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import createInvoice from 'src/services/invoice/createInvoice';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useLocation, useNavigate } from 'react-router';
import DeleteIcon from '@mui/icons-material/Delete';
const validationSchema = Yup.object({
    gst: Yup.number()
        .typeError("GST must be a number")
        .required("GST is required")
        .min(0, "GST cannot be negative"),
    payment_status: Yup.string().required("Payment status is required"),
});
export default function GenerateInvoice() {
    const { vendors, getVendor } = useContext(VendorContext);
    const { user, logout } = useAuthContext()
    const location = useLocation()
    const navigate = useNavigate()
    const [vendorId, setVendorId] = useState({ _id: "", name: "" })
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                await getVendor(0, true);
            } catch (error) {
                console.error(error);
            } finally {
            }
        };
        fetchVendor();
    }, []);
    const [paymentCheck, setPaymentCheck] = useState("Unpaid")
    const [data, setData] = useState([
        {
            "invoice_name": "",
            "amount": "",
            "description": ""
        }
    ])
    const handleStoreValue = (index, key, value) => {
        setData((prev) => {
            let update = [...prev]
            update[index][key] = value
            return update
        })
    }

    const handleAdd = () => {
        setData((prev) => {
            return [
                ...prev,
                {
                    "invoice_name": "",
                    "amount": "",
                    "description": ""
                }
            ]
        })
    }
    const handleRemove = (index) => {
        setData((prev) => {
            return prev.filter((_, ind) => ind != index)


        })
    }
    const { handleSubmit, values, errors, touched, handleBlur, setFieldValue, setValues } = useFormik({
        initialValues: {
            gst: "",
            raise_invoice_on: null,
            due_on: null,
            payment_date: null,
            payment_status: "Unpaid",
            note: ""
        },
        validationSchema,
        onSubmit: async (value) => {
            if (!vendorId._id) {
                return notify("Please select vendor.")
            }
            if (!value.raise_invoice_on) {
                return notify("Raise invoice on is required.")
            }
            if (!value.due_on) {
                return notify("Due Date on is required.")
            }

            for (let index = 0; index < data.length; index++) {
                const element = data[index];

                if (!element.invoice_name.trim()) {
                    return notify(`Invoice name is required in row ${index + 1}`);
                }

                if (element.amount === null || element.amount === undefined || element.amount === '') {
                    return notify(`Amount is required in row ${index + 1}`);
                }

            }
            const newData = {
                ...value,
                vendor_id: vendorId._id,
                raise_invoice_on: dayjs(value.raise_invoice_on).format(),
                payment_status: value.payment_status,
                gst_percentage: +value.gst,
                due_date: dayjs(value.due_on).format(),
                payment_date: dayjs(value.payment_date).format(),
                billing: data.map((it) => ({ ...it, amount: parseFloat(it.amount) }))

            }
            delete newData.gst
            delete newData.due_on
            let method = location.state ? "put" : "post"
            let url = location.state ?
                `/service/invoice_service/v1/invoice/update/${newData?._id}`
                : "/service/invoice_service/v1/invoice/general/create"
            const response = await createInvoice(user, newData, logout, url, method)
            if (response) {
                notify("Invoice generate successfully.", "success")
                navigate(-1)
            }


        }
    })
    useEffect(() => {
        if (location.state) {

            const { gst_percentage, initial_value, invoice_description, billing, invoice_name, note, payment_status, raise_invoice_on, due_date, vendor, payment_date, _id } = location.state
            setValues({
                gst: gst_percentage,
                payment_status,
                raise_invoice_on: dayjs(raise_invoice_on),
                due_on: dayjs(due_date),
                payment_date: dayjs(payment_date),
                _id: _id,
                note: note || ""
            })
            if (billing?.length) {
                setData(billing)
            } else {
                if (invoice_description || invoice_name) {
                    setData([
                        {
                            "invoice_name": invoice_name,
                            "amount": initial_value,
                            "description": invoice_description
                        }
                    ])
                }
            }
            setVendorId({ _id: vendor._id, name: vendor.name })
            setPaymentCheck(payment_status)
        }
    }, [location.state])

    const isEdit = location.state ? true : false
    console.log(data?.reduce((total, item) => {
        return total + (parseFloat(item.amount) || 0)
    }, 0));

    return (
        <Container>
            <Stack direction="row" mb="20px">
                <Typography sx={{ fontSize: "28px" }} color="primary" >
                    {
                        location.state ? "Update Invoice" : 'Generate Invoice'
                    }
                </Typography>
            </Stack>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={10} lg={7}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                                <Stack spacing={1}>
                                    <Typography variant="subtitle2">Select Vendors</Typography>
                                    <Autocomplete
                                        id="checkboxes-tags-demo"
                                        options={[...vendors]}
                                        limitTags={2}
                                        getOptionLabel={(option) => option.name}
                                        isOptionEqualToValue={(option, value) => option._id === value._id}
                                        renderOption={(props, option, { selected }) => {
                                            const { key, ...optionProps } = props;
                                            return (
                                                <li key={key} {...optionProps}>
                                                    {option.name}
                                                </li>
                                            );
                                        }}
                                        disabled={isEdit}
                                        value={vendorId}
                                        onChange={(_, val) => {
                                            setVendorId(val)

                                        }}

                                        style={{ width: "100%" }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Vendors"
                                                placeholder="Select Vendors" />
                                        )}
                                    />
                                </Stack>
                            </Grid>
                            {
                                <Grid item xs={12} >
                                    <Paper sx={{ padding: "15px" }}>
                                        {
                                            data?.map((it, index) => {
                                                return (
                                                    <Paper sx={{ padding: "15px", border: 1, borderColor: "divider", mb: 1 }} key={index}>
                                                        <Grid container spacing={2} >
                                                            <Grid item xs={12} >
                                                                <Stack direction="row" justifyContent="space-between" alignItems="center"
                                                                    sx={{ borderBottom: 1, borderColor: "divider" }}>
                                                                    <Typography>
                                                                        Invoice Info ({index + 1})
                                                                    </Typography>
                                                                    <IconButton disabled={isEdit || index == 0} color="error" onClick={() => handleRemove(index)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Stack>
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <CustomInput
                                                                    label="Invoice Name"
                                                                    input={
                                                                        <TextField fullWidth placeholder='Give a  Name to display'
                                                                            onChange={(e) => {
                                                                                handleStoreValue(index, e.target.name, e.target.value)
                                                                            }}
                                                                            name='invoice_name'
                                                                            onBlur={handleBlur}
                                                                            disabled={isEdit}
                                                                            value={it.invoice_name}

                                                                        />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <CustomInput
                                                                    label="Invoice Description"
                                                                    input={
                                                                        <TextField fullWidth placeholder='brief details about invoice'
                                                                            name='description'
                                                                            onChange={(e) => {
                                                                                handleStoreValue(index, e.target.name, e.target.value)
                                                                            }}
                                                                            disabled={isEdit}
                                                                            value={it.description}
                                                                        />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <CustomInput
                                                                    label="Billing Amount"
                                                                    input={
                                                                        <TextField fullWidth placeholder='Add a amount to raise invoice for'
                                                                            name='amount'
                                                                            onBlur={handleBlur}
                                                                            onChange={(e) => {
                                                                                const { name, value } = e.target;
                                                                                if (/^\d*\.?\d*$/.test(value) || value === '') {

                                                                                    handleStoreValue(index, name, value)
                                                                                }
                                                                            }}
                                                                            disabled={isEdit}
                                                                            value={it.amount}
                                                                        />
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                )
                                            })
                                        }
                                        <Stack mt={2} direction="row">
                                            <Button variant="outlined" disabled={isEdit} onClick={handleAdd}>Add</Button>
                                        </Stack>
                                    </Paper>
                                </Grid>
                            }

                            <Grid item xs={12} >
                                <CustomInput
                                    label="Total  GST (Taxes)"
                                    input={
                                        <TextField fullWidth placeholder='Add a amount to raise invoice for'
                                            onKeyDown={handleKeyPress}
                                            name='gst'
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                const { name, value } = e.target;
                                                const numericValue = Math.min(Number(value), 100); // clamp max to 100
                                                setFieldValue(name, numericValue)
                                            }}
                                            disabled={isEdit}
                                            value={values.gst}
                                            error={errors.gst && touched.gst}
                                            helperText={errors.gst && touched.gst ? errors.gst : ""}
                                            InputProps={
                                                {
                                                    endAdornment: (
                                                        <PercentIcon />
                                                    )
                                                }
                                            }
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}  >
                                <Stack spacing={1}>
                                    <Typography sx={{ display: "flex", gap: "10px" }}> Total Payable Amount: <Typography color="primary">₹{data?.reduce((total, item) => {
                                        return total + (parseFloat(item.amount) || 0)
                                    }, 0) + (data?.reduce((total, item) => {
                                        return total + (parseFloat(item.amount) || 0)
                                    }, 0) * (Number(values.gst) || 0) / 100)}</Typography></Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomInput
                                    label="Raise Invoice On"
                                    input={
                                        <DatePicker fullWidth placeholder='Add a amount to raise invoice for'
                                            name='raise_invoice_on'
                                            onBlur={handleBlur}
                                            sx={{ width: "100%" }}
                                            format='DD/MM/YYYY'
                                            onChange={(e) => {
                                                setFieldValue("raise_invoice_on", e)
                                            }}
                                            disabled={isEdit}
                                            value={values.raise_invoice_on}
                                            error={errors.raise_invoice_on && touched.raise_invoice_on}
                                            helperText={errors.raise_invoice_on && touched.raise_invoice_on ? errors.raise_invoice_on : ""}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6} >
                                <CustomInput
                                    label="Due Date"
                                    input={
                                        <DatePicker fullWidth placeholder='Add a amount to raise invoice for'
                                            name='due_on'
                                            onBlur={handleBlur}
                                            value={values.due_on}
                                            format='DD/MM/YYYY'
                                            sx={{ width: "100%" }}
                                            onChange={(e) => {
                                                setFieldValue("due_on", e)
                                            }}
                                            minDate={dayjs(values.raise_invoice_on)}
                                            disabled={isEdit}
                                            error={errors.due_on && touched.due_on}
                                            helperText={errors.due_on && touched.due_on ? errors.due_on : ""}
                                        />
                                    }
                                />
                            </Grid>

                            <Grid item xs={12}  >
                                <CustomInput
                                    label="Payment Status"
                                    input={
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name='payment_status'
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                setFieldValue("payment_status", e.target.value)
                                            }}
                                            value={values.payment_status}
                                            error={errors.payment_status && touched.payment_status}
                                            helperText={errors.payment_status && touched.payment_status ? errors.payment_status : ""}
                                        >
                                            <FormControlLabel value="Unpaid" control={<Radio disabled={paymentCheck == "Paid" && isEdit} />} label="Unpaid" />
                                            <FormControlLabel value="Paid" control={<Radio disabled={paymentCheck == "Paid" && isEdit} />} label="Paid" />
                                        </RadioGroup>
                                    }
                                />
                            </Grid>
                            {values.payment_status == "Paid" && <Grid item xs={12} md={6} >
                                <CustomInput
                                    label="Payment Date"
                                    input={
                                        <DatePicker fullWidth placeholder='Add a amount to raise invoice for'
                                            name='payment_date'
                                            value={values.payment_date}
                                            format='DD/MM/YYYY'
                                            sx={{ width: "100%" }}
                                            onChange={(e) => {
                                                setFieldValue("payment_date", e)
                                            }}
                                            // disabled={isEdit}
                                            minDate={dayjs(values.raise_invoice_on)}
                                        />
                                    }
                                />
                            </Grid>}
                            {(values.payment_status == "Paid" && location.state) && <Grid item xs={12} md={6} >
                                <CustomInput
                                    label="Note"
                                    input={
                                        <TextField fullWidth placeholder='Add a note'
                                            name='note'
                                            value={values.note}
                                            onChange={(e) => {
                                                setFieldValue("note", e.target.value)
                                            }}
                                        />
                                    }
                                />
                            </Grid>}
                            <Grid item xs={12}  >
                                <Stack direction="row" gap="10px" mt="20px">
                                    <Button variant="contained" type='submit'>
                                        {location.state ? "Update Invoice" : "Generate Invoice"}
                                    </Button>
                                    {/* <Button>
                                        Preview
                                    </Button> */}
                                    <Button variant="outlined" onClick={() => navigate(-1)}>
                                        Cancel
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}
